export { default } from './part-other-services';
